export default "__VITE_ASSET__OQ7mKrWk__"